import React from 'react';
import styles from '../../styles/Sidebar.module.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaMoneyCheckAlt, FaSignOutAlt } from 'react-icons/fa';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // You can add Firebase auth logout logic here if needed
    navigate('/admin');
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.header}>
        <h2>Hey! Admin</h2>
        <p>Welcomes You..!</p>
      </div>

      <nav className={styles.nav}>
        <NavLink
          to="/admin/dashboard"
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.active}` : styles.link
          }
        >
          <FaTachometerAlt className={styles.icon} />
          Admin Dashboard
        </NavLink>

        <NavLink
          to="/admin/routeprice"
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.active}` : styles.link
          }
        >
          <FaMoneyCheckAlt className={styles.icon} />
          Route Price
        </NavLink>

        <button className={styles.link} onClick={handleLogout}>
          <FaSignOutAlt className={styles.icon} />
          Logout
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
